const ArrowIcon = (props: any) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.73668 6.33333C6.73668 5.8731 7.10977 5.5 7.57001 5.5H14.2367C14.6969 5.5 15.07 5.8731 15.07 6.33333V13C15.07 13.4602 14.6969 13.8333 14.2367 13.8333C13.7764 13.8333 13.4033 13.4602 13.4033 13V8.34518L6.4926 15.2559C6.16716 15.5814 5.63952 15.5814 5.31409 15.2559C4.98865 14.9305 4.98865 14.4028 5.31409 14.0774L12.2248 7.16667H7.57001C7.10977 7.16667 6.73668 6.79357 6.73668 6.33333Z"
      fill="#0E1420"
    />
  </svg>
)
export default ArrowIcon
